import {customElement, property} from 'lit/decorators.js';
import {CSSResult, html, LitElement, TemplateResult,} from 'lit';
import {consume} from '@lit/context';
import {Messages} from '../../../@types/wishlist.js';
import {sharedCss} from '../../../scripts/style-bundle/shared.js';
import {i18nContext} from '../../../scripts/context/i18nContext.js';

interface OpenVspDrawerPayload {
  syan: number;
  farbId?: string;
  listName: string;
}

@customElement('ents-vsp-button')
export class VspButton extends LitElement {
  @property({type: Number, reflect: true})
  private syan: number = 0;

  @property({type: String})
  private name: string = '';

  @property({attribute: 'color-id', type: String, reflect: true})
  private colorId: string = '';

  @consume({context: i18nContext})
  private messages!: Messages;

  static get styles(): CSSResult {
    return sharedCss;
  }

  private getPayload(): OpenVspDrawerPayload {
    return {
      syan: this.syan,
      ...(this.colorId ? {farbId: this.colorId} : {}),
      listName: 'wishlist_cta',
    };
  }

  private emitEvent() {
    if (this.syan) {
      const payload = this.getPayload();
      document.dispatchEvent(new CustomEvent('suchen:vsp:alternativeprodukte', {detail: payload}));
      this.setAttribute('data-test-ents-vsp-button-payload-emitted', JSON.stringify(payload));
    }
  }

  protected render(): TemplateResult {
    return html`
      <div class="ents-vsp-button" @click="${this.emitEvent}" data-test-ents-vsp-button-shadow>
        <button
          class="bdk-button"
          type="button"
          variant="primary"
          size="medium"
          full-width
          aria-label="${this.messages['ents_wishlist_product_cta_vsp_aria_label']} ${this.name}"
        >
                    <span
                      class="ents-vsp-button__button-text">
                      ${this.messages['ents_wishlist_product_cta_vsp']}
                    </span>
        </button>
      </div>`;
  }
}
